<template>
  <el-form ref="form" :model="curInput.file" :rules="rules" label-width="100px">
    <el-form-item label="模板类型" prop="templet">
      <el-select v-model="curInput.file.templet" placeholder="请选择模板类型" class="h-40 w-200">
        <el-option v-for="(item, index) in uploadType" :label="item.name":value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="上传文件夹名" prop="dir_name">
      <el-input v-model.trim="curInput.file.dir_name" class="h-40 w-200" placeholder="请填写上传文件夹名"></el-input>
    </el-form-item>
    <el-form-item label="文件大小" prop="file_max">
      <el-input v-model.trim="curInput.file.file_max" class="h-40 w-100"></el-input>
      <el-select v-model="curInput.file.file_unit" placeholder="请选择文件大小单位" class="h-40 w-100">
        <el-option v-for="(item, index) in fileUnit" :label="item.name":value="item.id"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="文件类型(不选默认不限制)" prop="file_type">
      <el-checkbox v-model="curInput.file.checkAllFile" @change="checkAllChange(curInput.file)">全选</el-checkbox>
      <el-checkbox-group v-model="curInput.file.file_type">
        <el-checkbox v-for="(item, index) in fileType" :label="item.id" @change="isCheckAll(curInput.file)">{{ item.name }}{{ item.explain }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <!-- <el-form-item label="请求参数" prop="">
      <el-input class="h-40 w-200" placeholder="请填写请求参数"></el-input>
    </el-form-item> -->
  </el-form>
</template>

<script>
  import _verify from '../../../assets/js/verify'
  export default {
    props: ['curInput'],
    data() {
      return {
        rules: {
          templet: [
            { required: true, message: '请选择模板类型' }
          ],
          dir_name: [
            { required: true, message: '请填写上传文件夹名' },
            { validator: this.checkChinese, trigger: 'blur' }
          ],
          file_max: [
            { required: true, message: '请填写文件大小' }
          ]
        },
        fileType: [
          { id: 10, name: '图片', explain: '(jpg, jpeg, png, bmp, gif, tiff)' },
          { id: 20, name: '压缩文件', explain: '(rar, zip, 7z)' },
          { id: 30, name: 'word文档', explain: '(doc, docx)' },
          { id: 40, name: 'excel表格', explain: '(xls, xlsx, csv)' },
          { id: 50, name: '幻灯片', explain: '(ppt, pptx)' },
          { id: 60, name: 'PDF', explain: '(pdf)' }
        ],
        uploadType: [
          { id: 10, name: '上传文件列表' },
          { id: 20, name: '图片列表' },
          { id: 30, name: '照片墙' },
          { id: 40, name: '拖拽上传' }
        ],
        fileUnit: [
          { id: 10, name: 'KB' },
          { id: 20, name: 'MB' }
        ]
      }
    },
    created() {
      this.isCheckAll(this.curInput.file)
    },
    methods: {
      checkAllChange(config) {
        if (config.checkAllFile) {
          config.file_type = []
          _.forEach(this.fileType, (value, key) => {
            config.file_type.push(value.id)
          })
        } else {
          config.file_type = []
        }
      },
      isCheckAll(config) {
        if (config.file_type.length != this.fileType.length) {
          config.checkAllFile = false
        } else {
          config.checkAllFile = true
        }
      },
      checkChinese(rules, value, callback) {
        if (_verify.isChinese(value)) {
          callback('文件夹名不能为中文')
        } else {
          callback()
        }
      }
    },
    watch: {
      'curInput'() {
        this.isCheckAll(this.curInput.file)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// fileConfig.vue?8deb73f0